import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)
import fetch from '@/fetch'

export default new Factory(resource, {
  clone(id) {
    return fetch(`/api/residential-template/${id}/clone`, { method: 'POST' }).then(res => res.json())
  },
})
